<template>
    <div class="row" v-if="!isLoggedIn">
        <div class="kedvenciam_all_area">
            <div class="col-sm-12">
                <div class="single_kedvenciam_all">
                    <div class="row">
                        <div class="col-sm-12" style="margin-top:30px;margin-bottom:30px;">
                                    <div class="col-sm-12 center-div final-cont text-center" v-if="success">
                                        <img src="images/ok.png" alt="" />
                                        <h2>Rendelésedet rögzítettük, visszaigazoló emailt küldtünk az email címedre, hamarosan felvesszük veled a kapcsolatot.</h2>
                                    </div>
                                    <div class="col-sm-12 center-div final-cont text-center" v-if="fail">
                                        <h2>Hiba történt a fizetés során. Ha úgy gondolod hogy fizetésed mégis érvényes volt, kérlek vedd fel velünk a kapcsolatot.</h2>
                                    </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Endpoints from '@commons/communication/endpoints.js'

export default {
    mixins:[Endpoints],
    data:function () {
        return {
            success: false,
            fail: false,
        };
    },
    mounted:function () {
        var id = this.$route.query.txid;
        if (id == 'nopay'){
            this.success = true;
        }else{
            var self = this;
            this.connCheckPayment(id,function (r) {
                if (r.data == 'PREPARED'){
                    self.success =true;
                }else{
                    self.fail = true;
                }
            })
        }
    }
}
</script>

<style scoped>
img {
    width: 30%;
}
.center-div{
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// FlowFinal.vue?7e34627c